module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels2_BW-b948f66cf46a16f02065eb3a28376686.jpg";